import {GooglePlaceID, Place} from "./places/PlaceTypes"
import {AirportStopInput, JourneyInput, PlaceFragment} from "../graphql/queries"
import {BookingFormAirportState, BookingFormJourneyState} from "../state"

export function somePlaceId(placeId: GooglePlaceID) {
  return placeId !== ""
}

export function googlePlaceId(place: Place | null) {
  return place ? place.googlePlaceId : ""
}

export function journeyToInputJourney(journey: BookingFormJourneyState): JourneyInput {
  return {
    originId: journey.origin!.id,
    destinationId: journey.destination!.id,
    waypointIds: journey.waypoints.map((it) => it.id),
  }
}

export function airportStopToInput(
  place: PlaceFragment,
  stop: BookingFormAirportState,
): AirportStopInput | null {
  return place.isAirportStop
    ? {
        airlineCode: stop.airlineCode,
        flightType: stop.flightType,
        flightNumber: stop.flightNumber,
      }
    : null
}



// WEBPACK FOOTER //
// ./src/model/journey.ts